import { InjectionTokens } from '@/controller/tokens'

import { useInjection } from '../contexts/InjectionContext'

import { I18n } from '@/i18n/I18n'

export function useI18n() {
  const i18n = useInjection<I18n>(InjectionTokens.I18n)

  return {
    t: i18n.resolveToken.bind(i18n),
    lang: i18n.getLanguage.bind(i18n),
    getTimeFormat: i18n.getTimeFormat.bind(i18n),
    getDateFormat: i18n.getDateFormat.bind(i18n),
    getStandardizedDate: i18n.getStandardizedDate.bind(i18n),
    getStandardizedDateUTC: i18n.getStandardizedDateUTC.bind(i18n),
    getStandardizedDateTimeUTC: i18n.getStandardizedDateTimeUTC.bind(i18n)
  }
}
